import { render, staticRenderFns } from "./OAuthSuccess.vue?vue&type=template&id=04bc8a7c&scoped=true"
import script from "./OAuthSuccess.vue?vue&type=script&lang=js"
export * from "./OAuthSuccess.vue?vue&type=script&lang=js"
import style0 from "./OAuthSuccess.vue?vue&type=style&index=0&id=04bc8a7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc8a7c",
  null
  
)

export default component.exports